<template>
  <div class="dilog" v-if="dialogFormVisible">
      <div class="content form-wrap" style="padding:0">
        <div class="title">修改密码</div>
        <form class="form" style="padding:4vw 5vw 5vw">
        <table width="100%">
          <tbody>
            <tr>
              <td>旧密码：</td>
              <td style="width:70% ">
                <label>
                <input type="password" class="ipt-6" v-model="form.oldpwd" autocomplete="off"/>
                </label>
              </td>
            </tr>
            <tr>
              <td>新密码：</td>
              <td>
                <label>
                <input type="password" class="ipt-6" v-model="form.newpwd" autocomplete="off"/>
                </label>
              </td>
            </tr>
            <tr>
              <td>确认密码：</td>
              <td>
                <label>
                <input type="password" class="ipt-6" v-model="form.confirmpwd" autocomplete="off"/>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="text-align:center;margin-top:10px">
          <button type="sure" class="form-btn" @click.prevent="updatepassword">确 认</button>
          <button type="info" class="form-btn" @click.prevent="reset">重 置</button>
        </div>
        </form>
      </div>
  </div>

  <div class="login-wrap container" v-else>
    <action-bar title="用户登录" :left="false" :l="false" :pc="true"></action-bar>
    <main class="v-main">
      <div class="main-bg">
        <div class="main-logo-box">
          <img class="main-logo" src="../../../static/images/login/logo1.png">
        </div>
      </div>
      <section class="form-wrap">
        <form class="form">
          <h1 class="form-title">用户登录</h1>
          <label>
            <img class="input-prefix-img" src="../../../static/images/login/zhang.png">
            <input type="text" v-model="username" placeholder="请输入用户名">
          </label>

          <label>
            <img class="input-prefix-img" src="../../../static/images/login/word.png">
            <input type="password" v-model="password" placeholder="请输入密码">
            <img class="input-prefix-img input-prefix-password-img" src="../../../static/images/login/word1.png">
          </label>

          <label v-if="codeInfo!=2">
            <img class="input-prefix-img" src="../../../static/images/login/zhang.png">
            <input type="text" v-model="code" placeholder="请输入验证码">
            <img class="code-wrap" @click="refreshVerifyCode" :src="code_url"/>
          </label>

          <button type="submit" class="form-btn" @click.prevent="loginApp" :disabled="isButtonDisabled">{{ buttonText }}</button>
        </form>
      </section>
    </main>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import ActionBar from '../../components/action-bar'
  import { password } from "@/service/user";
  import { getCode } from '@/service/user'

  export default {
    name: "login",
    components: {ActionBar},
    data() {
      return {
        buttonText: '立即登录',
        isButtonDisabled: false,
        username: '',
        password: '',
        code: '',
        num: 1,
        dialogFormVisible: false,
        form: {
          oldpwd: '',
          newpwd: '',
          confirmpwd: '',
        },
        codeInfo:''
      }
    },
    mounted() {
      this.queries = this.$route.query;
      this.getCode();
    },
    watch: {
      code() {
      if(this.code.length>4){
        this.code = this.code.substring(0,4);
      }
      }
    },
    computed: {
      code_url() {
        return `/api/ssc_golang/v1/user/captcha?n=${this.num}`;
        //return `http://go.dev8899.com/api/ssc_golang/v1/user/captcha?n=${this.num}`;
      }
    },
    methods: {
      ...mapActions('root', [
        'login'
      ]),
      async getCode() {
        this.codeInfo = await getCode();
      },
      refreshVerifyCode() {
        this.num++;
      },
      reset(){
        this.form={};
      },
      updatepassword(){
        let vm = this;

        let params = {
          old_password: vm.form.oldpwd,
          password: vm.form.newpwd,
          password_confirm: vm.form.confirmpwd
          };
        if(params.old_password==""){
          this.$toast.center("原密码不能为空");
          return false
        }
        if(params.password==""){
          this.$toast.center("新密码不能为空");
          return false
        }
        if(params.password_confirm==""){
          this.$toast.center("确认密码不能为空");
          return false
          }
        password(params).then(res=>{
              if(res.result == 'ok'){
                  this.$toast.center("密码修改成功，下次登录请使用新密码");
                  this.num++;
                  this.dialogFormVisible = false;
                  this.password = "";
			            this.code = "";
              }else{
                  this.$toast.center(res.msg);
              }
        })
      },
      async loginApp(e) {
        /* 表单验证 */
        if(this.codeInfo!=2){
          var info = this.$validate.group(
            this.$validate("username", this.username),
            this.$validate("password", this.password),
            this.$validate("code", this.code)
          );
        }else{
          var info = this.$validate.group(
            this.$validate("username", this.username),
            this.$validate("password", this.password)
          );
        }
        if (info) return this.$toast.center(info);
        this.buttonText = '登录中，请稍候';
        this.isButtonDisabled = true;
        this.login({
          username: this.username,
          password: this.password,
          code: this.code,
        }).then(res => {
          if (res.result !== 'ok') {
            this.isButtonDisabled = false;
            this.buttonText = '立即登录';
            if(res.msg=="请您进行密码更换")
            {
              this.dialogFormVisible=true;
            }
            return this.$toast.center(res.msg);
          }
          if(res.msg=='3'){
            this.isButtonDisabled = false;
            this.buttonText = '立即登录';
            this.$toast.center('该帐号已被冻结，请联系您的上级！');
          }
          this.buttonText = '登录成功，正在跳转';
          this.num++;
          this.$router.replace(this.queries.path || '/agreement');
        });
      }
    },
  }
</script>

<style lang="less">
.dilog {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  .content {
    margin: 27vw 5vw;
    width: 90%;
    min-height: 93vw;
    border-radius: 3vw;
    background-color: #fff;
    position: fixed;
    .title {
      height: 80px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: linear-gradient(#f3382c,#da2d23);
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
    .table {
      overflow-y: scroll;
      height: 500px;
      padding: 0 10px;
      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        font-size: 12px;
      }
    }

    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      button {
        width: 180px;
        height: 50px;
        margin: 20px;
        border-radius: 10px;
      }
    }
  }
}

  .login-wrap {
    background-color: #ededed;
  }

  .main-bg {
    height: 400px;
    background-image: url("../../../static/images/login/bg1.png");
    background-position: bottom;
    background-repeat: no-repeat;

    .main-logo-box {
      position: absolute;
      right: 0;
      left: 0;
      top: 150px;
      margin: 0 auto;
      padding: 30px;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 0 1px 11px #44444463;
      .main-logo {
        width: 100px;
        height: 100px;
      }
    }
  }

  .form-wrap {
    position: relative;
    padding: 28px 38px 38px;
    box-sizing: border-box;
    margin-top: -100px;
    background: #fff;
    border-radius: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;

    .form {
      .form-title {
        margin-bottom: 15px;
        height: 80px;
        line-height: 80px;
        color: #ff4444;
        font-size: 40px;
        text-align: center;
        border-bottom: 1px solid #ff4444;
      }

      label {
        height: auto;
        display: flex;
        padding: 5px 0;
        border-bottom: 1px solid #f1f1f1;

        input {
          width: 100%;
          border: none;
          height: 76px;
          display: block;
          padding: 0 20px;
          font-size: 30px;
          background: #fff;
          box-sizing: border-box;
          line-height: normal;
          border-radius: 10px;
          vertical-align: middle;
          outline: none;
        }

        .code-wrap {
          width: 180px;
          height: 70px;
          display: block;
          border-radius: 10px;
          background-color: #3bb4f2;
        }
      }

      label ~ label {
        margin-top: 30px;
      }

      button[type="submit"] {
        width: 100%;
        color: #fff;
        height: 80px;
        border: 1px solid #da2d23;
        font-size: 32px;
        background-color: #ff4444 !important;
        text-indent: 6px;
        font-weight: 600;
        border-radius: 6px;
        margin-top: 50px;
        letter-spacing: 6px;
        text-decoration: none;
      }

      button[type="primary"] {
        width: 68%;
        color: #fff;
        height: 80px;
        border: 1px solid #da2d23;
        font-size: 32px;
        background-color: #ff4444 !important;
        text-indent: 6px;
        font-weight: 600;
        border-radius: 6px;
        margin-top: 50px;
        letter-spacing: 6px;
        text-decoration: none;
      }

      button[type="sure"] {
        width: 40%;
        color: #fff;
        height: 80px;
        border: 1px solid #da2d23;
        font-size: 32px;
        background-color: #ff4444 !important;
        text-indent: 6px;
        font-weight: 600;
        border-radius: 6px;
        margin-top: 50px;
        letter-spacing: 6px;
        text-decoration: none;
      }

      button[type="info"] {
        width: 40%;
        color: #fff;
        height: 80px;
        font-size: 32px;
        text-indent: 6px;
        font-weight: 600;
        border-radius: 6px;
        margin-top: 50px;
        letter-spacing: 6px;
        text-decoration: none;
      }

      .input-prefix-img {
        margin-top: 6px;
        width: 60px;
        height: 68px;
      }

      .input-prefix-password-img {
        margin-top: 30px;
        width: 40px;
        height: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue